module.exports = __webpack_public_path__ + "img/feature-item-org.425e4ed5.svg";